import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import Button from '@/shared/Button'
import { useTranslation } from 'react-i18next'

const EmailDialog = ({ details, title, ...props }) => {
  const { emailContent, emailSubject, senderName, snederAddress } = details || {}
  const { onClose } = props

  const { t } = useTranslation()

  return (
    <Dialog {...props} fullWidth maxWidth="lg">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ backgroundColor: '#ecf1f2', padding: 2, fontSize: 14 }}>
          <Grid item container spacing={1}>
            <Grid item xs={2}>
              <Typography variant="subtitle2" sx={{ color: '#555' }}>
                {t('general.sender')}
              </Typography>
            </Grid>
            <Grid item>
              <Box display="flex" alignItems="flex-end">
                {senderName}
                <Typography ml={1} variant="caption" sx={{ color: '#555' }}>
                  {`<${snederAddress}>`}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid item container spacing={1} mt={0}>
            <Grid item xs={2}>
              <Typography variant="subtitle2" sx={{ color: '#555' }}>
                {t('general.subject')}
              </Typography>
            </Grid>
            <Grid item>
              <Box display="flex" alignItems="flex-end">
                {emailSubject}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <div dangerouslySetInnerHTML={{ __html: emailContent }} />
      </DialogContent>
      <DialogActions>
        <Button color="neutral" onClick={() => onClose()}>
          {t('general.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EmailDialog
